import { getToken, onMessage } from "firebase/messaging";
import { registerDeviceTokenApi } from "../API/notifications";
import { getMessagingIfSupported, VAPID_KEY } from "./firebase";

let started = false;

// Registers the FCM service worker, requests notification permission, obtains a
// web push token and registers it with the backend (platform "web") so this
// browser receives pushes even when the tab is closed. Also wires foreground
// messages to [onForeground]. Safe to call more than once (guards itself).
export const initWebPush = async (onForeground) => {
  if (started) return;
  started = true;

  if (!("serviceWorker" in navigator) || !("Notification" in window)) return;

  const messaging = await getMessagingIfSupported();
  if (!messaging) return;

  try {
    const registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return;

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });
    if (token) {
      try {
        await registerDeviceTokenApi(token, "web");
      } catch (_) {
        // non-fatal
      }
    }

    // Foreground messages (tab focused) aren't auto-displayed by the browser.
    onMessage(messaging, (payload) => {
      if (onForeground) onForeground(payload);
    });
  } catch (_) {
    // Service worker / token errors are non-fatal — in-app polling still works.
  }
};
